// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDoTJXDL6-Zgb1EqLxBt5eJ38gWks-Ey5I",
  authDomain: "invest-project-rizosbank.firebaseapp.com",
  projectId: "invest-project-rizosbank",
  storageBucket: "invest-project-rizosbank.firebasestorage.app",
  messagingSenderId: "949017798049",
  appId: "1:949017798049:web:c32eb2da78db2339c017e0",
  measurementId: "G-7SZM3PM5CR"
};



// Initialize Firebase
export const appFirebase = initializeApp(firebaseConfig);
export const storageFirebase = getStorage(appFirebase);
export const authFirebase = getAuth(appFirebase);
export const dbFirebase = getFirestore(appFirebase);

//cLAVE App Check: QA-TESTING-2024